import React, { Component } from 'react';

import InputBox from '../../../../etc/InputBox';

class QuestionItem extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onChange = (e) => {
    console.log(e);
  };
  
  render() {
    return (
      <>
        <div className="card col-md-12">
          <div className="card-header">
            저자에게 문의
          </div>
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-md-6">
                <InputBox
                  title="질문자"
                  value={[{ value : "김석사 [202081234]" }]}
                />
              </div>
              <div className="col-md-6">
                <InputBox
                  title="질문일자"
                  value={[{ value : "2021-06-05" }]}
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-12 form-group">
                <label htmlFor="journal_title"><strong>질문내용</strong></label>
                <textarea className="form-control" placeholder="" id=""></textarea>
              </div>
            </div>
          </div>
        </div>

        <div className="card col-md-12">
          <div className="card-header">
            문의 답변
          </div>
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-md-6">
                <InputBox
                  title="답변자"
                  value={[{ value : "왕박사 [202081234]" }]}
                />
              </div>
              <div className="col-md-6">
                <InputBox
                  title="답변일자"
                  value={[{ value : "2021-06-05" }]}
                />
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-md-12 form-group">
                <label htmlFor="journal_title"><strong>답변내용</strong></label>
                <textarea className="form-control" placeholder="" id=""></textarea>
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default QuestionItem;